import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'
import {
  useSimpleBlogTemplate,
  useSimpleBlogUpdate,
} from 'Event/template/SimpleBlog'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import ColorPicker from 'lib/ui/ColorPicker'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import {Controller} from 'react-hook-form'

export default function DashboardLinkConfig() {
  const saveTemplate = useSimpleBlogUpdate()
  const {speakers} = useSimpleBlogTemplate()
  const addTranslation = useAddTranslation()

  const {
    form: {control, register},
  } = useConfig()

  const v = useAttendeeVariables()

  const save = (data: any) => {
    const backToDashboardText = replaceAtPath(
      data,
      'speakers.backToDashboardText',
      '{{speakers_back_to_dashboard_text}}',
    )
    saveTemplate({
      ...data,
      localization: addTranslation({
        speakers_back_to_dashboard_text: backToDashboardText ?? '',
      }),
    })
  }

  return (
    <Config title="Dashboard Link" onSave={save}>
      <SettingsPanel>
        <TextField
          defaultValue={v(speakers.backToDashboardText)}
          name="speakers.backToDashboardText"
          label="Back to Dashboard Text"
          fullWidth
          inputProps={{
            ref: register,
            'aria-label': 'back to dashboard text',
          }}
        />
      </SettingsPanel>
      <StylingPanel>
        <Controller
          name="speakers.backToDashboardTextColor"
          defaultValue={speakers.backToDashboardTextColor}
          control={control}
          render={({onChange, value}) => (
            <ColorPicker
              label="Back to Dashboard Text Color"
              color={value}
              onPick={onChange}
              aria-label="text color"
            />
          )}
        />
      </StylingPanel>
    </Config>
  )
}
